import React from "react";

export default function FAQ() {
  return (
    <section className="pc:col-span-10 col-span-8 grid grid-cols-subgrid gap-y-10">
      <section className="pc:col-span-5 pc:gap-5 col-span-8 flex flex-col gap-4">
        <h2 className="text-title">FAQ</h2>
        <article className="pc:gap-5 col-span-8 flex flex-col gap-4 wrap-break-word">
          <div className="flex flex-col gap-1">
            <span>Q. 注文確定後に支払い方法の変更は出来ますか？</span>
            <span>A. 当社のシステム上、購入完了後の支払い方法の変更はお受け致しかねます。</span>
          </div>
          <div className="flex flex-col gap-1">
            <span>Q. 注文確認メールが届きません。</span>
            <span>
              A.
              通常、ご注文手続き完了後にご注文内容を記載した確認メールを自動配信にてお送り致しております。購入申し込みを行ってから24時間を経過しても確認通知が届かない場合は正常にご注文が完了していない、又はご入力いただいたメールアドレスに相違がある可能性等もございますので受注番号(#JP0000)、お名前、お電話番号とあわせまして「CONTACT」にてお問い合わせください。
            </span>
          </div>
          <p className="flex flex-col gap-1">その他、詳細につきましては当社、利用規約をご確認下さい。</p>
        </article>
      </section>
    </section>
  );
}
